import React, { Component } from 'react'
import PropTypes from 'prop-types'

import GridContainer from './../shared/GridContainer'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

import './Deepening.css'

class Deepening extends Component {

    /* Handlers */

    /* Lifecycle */
     
    render() {
        return (
            <div className="pages-deepening">
                <GridContainer>
                    <Grid item xs={12}>
                    
                        <br />
                        <br />

                        <Typography variant="display1" gutterBottom>
                            Metodologia di recupero e analisi dati Travel Appeal
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                            Travel Appeal ha raccolto e monitorato la presenza digitale dell&#39;offerta ricettiva italiana
                            attraverso l’analisi dei siti di recensioni, delle OTA e dei social media più diffusi in Italia come
                            TripAdvisor, Booking.com, Google, Expedia, Hotels.com, Facebook, Airbnb, Homeaway ed
                            altri. Per ciascuna struttura rilevata, Travel Appeal ne esplora la tipologia, la categoria, le
                            recensioni (testi e punteggi), la provenienza degli ospiti, la lingua, la tipologia degli ospiti, i
                            servizi offerti.
                            La metodologia di recupero prevede un processo di ricognizione sui vari canali utilizzati dalle
                            strutture ricettive, per il quale ogni struttura alberghiera o extralberghiera è considerata
                            univoca anche se presente su molteplici canali di recensione, OTA, social media.
                            Diversamente, per gli annunci di appartamenti ed altre categorie di affitti a breve termine,
                            non è possibile applicare il medesimo processo di ricognizione.
                        </Typography>

                    </Grid>

                    <Grid item xs={12}>

                        <Typography variant="display1" gutterBottom>
                            Glossario dati
                        </Typography>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell width="20%"><strong>Indicatore</strong></TableCell>
                                    <TableCell width="80%"><strong>Descrizione</strong></TableCell>    
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>
                                        <Typography variant="body1" gutterBottom>
                                            <strong>Soddisfazione generale degli ospiti e Sentiment positivo</strong>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body1" gutterBottom>
                                            Il Sentiment è un valore che indica il livello di percezione positiva, la
                                            soddisfazione dell’ospite, rispetto all’esperienza generale o ad un
                                            singolo aspetto che emerge dall’analisi semantica di un contenuto
                                            testuale (recensione, testo o post), sfruttando un motore semantico
                                            specializzato in grado di “leggere” ogni singolo contenuto, rilevarne i
                                            soggetti citati e comprendere le opinioni associate a quest’ultimi. Un
                                            giudizio (o opinione) incide sulla percentuale di sentiment in base: 
                                        </Typography>    
                                        <ol>
                                            <li>al soggetto al quale si riferisce (camera, personale, wifi, guida, servizi, ecc.);</li>
                                            <li>alla connotazione degli aggettivi, degli avverbi e dei verbi utilizzati per valutare tale soggetto;</li>
                                            <li>al rating che l’utente recensore assegna;</li>
                                            <li>al peso in base al grado di positivià/negatività dell’aggettivo/avverbio/verbo rilevato.</li>
                                        </ol>
                                        <Typography variant="body1" gutterBottom>    
                                            I contenuti
                                            vengono quindi “smontati” in molteplici argomenti (cluster), in cui è
                                            possibile verificare gli elementi che influenzano positivamente e/o
                                            negativamente l’esperienza degli utenti. Un contenuto è considerato
                                            “positivo” quando il sentiment delle opinioni espresse raggiunge
                                            almeno il 55% di positività; è considerato “negativo” quando il
                                            sentiment delle opinioni espresse è al di sotto del 55% di positività.
                                            L’analisi semantica sulle recensioni è sintetizzata nel valore
                                            percentuale del Sentiment positivo e, nel complesso, nella
                                            soddisfazione generale.
                                        </Typography>    
                                    </TableCell> 
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Typography variant="body1" gutterBottom>
                                            <strong>Soddisfazione degli ospiti stranieri</strong>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body1" gutterBottom>
                                            È il Sentiment positivo delle recensioni con provenienza e/o lingua diversa dall&#39;italiano.
                                        </Typography>
                                    </TableCell> 
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Typography variant="body1" gutterBottom>
                                            <strong>Recensioni delle strutture ricettive</strong>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body1" gutterBottom>
                                            È la quantità di recensioni totale delle strutture ricettive alberghiere
                                            ed extralberghiere ad esclusione degli appartamenti e altre tipologie
                                            di affitti a breve termine.
                                        </Typography>
                                    </TableCell> 
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Typography variant="body1" gutterBottom>
                                            <strong>Recensioni degli appartamenti</strong>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body1" gutterBottom>
                                            È la quantità di recensioni totale degli appartamenti e altre tipologie
                                            di affitti a breve termine.
                                        </Typography>
                                    </TableCell> 
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Typography variant="body1" gutterBottom>
                                            <strong>% Recensioni rispetto all’Italia</strong>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body1" gutterBottom>
                                            È la distribuzione percentuale della quantità di recensioni rispetto al totale Italia.
                                        </Typography>
                                    </TableCell> 
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Typography variant="body1" gutterBottom>
                                            <strong>Strutture ricettive</strong>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body1" gutterBottom>
                                            È la quantità di strutture ricettive alberghiere ed extralberghiere
                                            presenti online ad esclusione degli appartamenti e altre tipologie di
                                            affitti a breve termine.
                                        </Typography>
                                    </TableCell> 
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Typography variant="body1" gutterBottom>
                                            <strong>Annunci di appartamenti</strong>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body1" gutterBottom>
                                            È la quantità di annunci di appartamenti e altre tipologie di affitti a
                                            breve termine presenti online.
                                        </Typography>
                                    </TableCell> 
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Typography variant="body1" gutterBottom>
                                            <strong>% Strutture rispetto all’Italia</strong>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body1" gutterBottom>
                                            È la distribuzione percentuale della quantità di strutture ricettive o di
                                            annunci degli appartamenti rispetto al totale Italia.
                                        </Typography>
                                    </TableCell> 
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Typography variant="body1" gutterBottom>
                                            <strong>Presenze</strong>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body1" gutterBottom>
                                            Numero di pernottamenti effettuati presso strutture ricettive o altri alloggi.
                                        </Typography>
                                        <Typography variant="body1" gutterBottom>
                                            È opportuno rilevare, come ben illustrato da Becheri et. al., che “gli
                                            arrivi e le presenze ufficialmente rilevate dall’ISTAT come
                                            movimento turistico sono i documenti più affidabili e più attendibili
                                            per le analisi e per i confronti temporali, ma non rilevano l’intero
                                            fenomeno del turismo perché non sono considerati gli arrivi e i
                                            pernottamenti nelle abitazioni per vacanza; infatti, non vi è alcun
                                            obbligo di rilevazioni se non per quella parte gestita
                                            imprenditorialmente, che rappresenta una entità minima rispetto alle
                                            strutture effettivamente utilizzate” (Becheri E., Micera R., Morvillo
                                            A., Rapporto sul turismo italiano, XXI edizione 2016/2017, Rogiosi
                                            Editore, 2018, p. 60).
                                        </Typography>
                                        <Typography variant="body1" gutterBottom>
                                            Per ovviare si rende necessario il ricorso a modelli utili a stimare in
                                            maniera verosimile i pernottamenti avvenuti, ad esempio, a seguito
                                            di contratti di locazione breve: “La stima dei movimenti turistici
                                            connessi alle seconde case è operazione complessa e fonte di
                                            discussione tra i ricercatori, il calcolo generalmente viene realizzato
                                            attraverso l’analisi di indicatori indiretti, ma sulla loro individuazione
                                            e successiva ponderazione non esiste ancora una
                                            metodologia condivisa. Gli indicatori indiretti sono molteplici, non
                                            sempre disponibili su tutto il territorio nazionale: consumo di energia
                                            elettrica, rifiuti, vendita dei giornali, vendita di pane e altri prodotti
                                            alimentari, uscite caselli autostradali, movimento negli aeroporti…”
                                            (cfr. Caselli G., Il turismo invisibile, Osservatorio regionale sul
                                            turismo dell’Emilia-Romagna, 2017, pp. 44-45).
                                        </Typography>
                                        <Typography variant="body1" gutterBottom>
                                            A tal scopo lo stesso Becheri ha sviluppato da tempo un
                                            moltiplicatore del movimento turistico non rilevato (cfr. Becheri E. et
                                            al., a cura di Mercury Srl, Il turismo che non appare. Il ruolo delle
                                            abitazioni per vacanza, Osservatorio Regionale del Turismo della
                                            Toscana, 2009). Si tratta di un coefficiente che ricalibra il numero di
                                            presenze fornite dall’ISTAT al movimento turistico reale in un
                                            territorio, tenendo conto di fattori quali, a titolo esemplificativo, le
                                            utenze telefoniche, elettriche e idriche, l’acquisto di giornali, la
                                            gestione dei rifiuti, gli spostamenti ferroviari, aerei e automobilistici.
                                            Il moltiplicatore varia perciò da regione a regione e vuole
                                            considerare anche i movimenti turistici presenti nelle locazioni
                                            turistiche e nelle seconde case.
                                        </Typography>
                                        <Typography variant="body1" gutterBottom>
                                            Valutazioni, assolute o percentuali, riguardo il totale presenze
                                            stimate o parte di esse (es. Airbnb) su Italia Destinazione Digitale
                                            sono sviluppate facendo ricorso al moltiplicatore del prof. Becheri e
                                            della società Mercury Srl.
                                        </Typography>
                                    </TableCell> 
                                </TableRow>

                            </TableBody>
                        </Table>

                    </Grid>
                    <Grid item xs={12}>
                        <br />
                        <br />
                        <Typography variant="body1">
                            <a href="" onClick={this.context.router.history.goBack}>Indietro</a>
                        </Typography>
                        <br />
                    </Grid>

                </GridContainer>
            </div>       
        )
    }
}

Deepening.contextTypes = {
    t: PropTypes.func,
    router: PropTypes.object
}

export default Deepening

/*

<TableRow>
    <TableCell>
        <Typography variant="body1" gutterBottom>
            <strong></strong>
        </Typography>
    </TableCell>
    <TableCell>
        <Typography variant="body1" gutterBottom>

        </Typography>
    </TableCell> 
</TableRow>

onClick={this.context.router.history.goBack}

*/


// WEBPACK FOOTER //
// ./src/components/pages/Deepening.js